<script setup lang="ts">
import { useStore } from '@/core/composables/useStore';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BatchJobs from '../status-elements/BatchJobs.vue';

const { state } = useStore();
const { t } = useI18n();
const { decodedToken, keycloak } = useKeycloak();

const tabs = computed(() => state.header?.tabs);
const breadcrumbs = computed(() => state.header?.breadcrumbs);

const emits = defineEmits(['onShowSettingsPanel']);

//#region User Info
const userInfo = computed(() => state.userInfo?.userInfo);
//#endregion

//#region Bugs
function openBugReport() {
   window.open(`${location.origin}/bug-report`);
}
//#endregion
</script>

<template>
   <NxtPageHeader
      class="page-header"
      :user-info="userInfo"
      :modules="userInfo?.modules"
      :user-actions="[{ label: t('actions.log-out'), iconClass: 'fa-solid fa-arrow-right-from-bracket', to: keycloak.createLogoutUrl() }]"
      :fallback-username="decodedToken?.preferred_username"
      :manage-organisation-text="$t('actions.manage-organisation')"
   >
      <template #breadcrumbs>
         <RouterLink
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
            v-bind="breadcrumb"
            :title="breadcrumb.to"
            :class="{ active: index === (breadcrumbs?.length || 0) - 1 }"
         >
            {{ breadcrumb.content }}
         </RouterLink>
      </template>
      <template #tabs>
         <RouterLink v-for="(tab, index) in tabs" :key="index" v-bind="tab" :title="tab.to" exact-active-class="active">
            {{ tab.content }}
         </RouterLink>
      </template>
      <template #globalActions>
         <!-- Bug Report -->
         <NxtIconButton :name="'bug'" :hover-text="$t('generic.bug-report')" @on-click="openBugReport" />

         <!-- Batch Jobs -->
         <BatchJobs />

         <!-- Settings -->
         <NxtIconButton :name="'cog'" :hover-text="$t('settings.settings')" @on-click="emits('onShowSettingsPanel')" />
      </template>
   </NxtPageHeader>
</template>
